import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// components
import Header from './components/Header';
import Nav from './components/Nav';import Home from './components/Home';
import Artistas from './components/Artistas';
import ArtistaLayout from './components/ArtistaLayout';
import NotFound from './components/NotFound';

const App = () => {
  return (
    <Router>
      <div className='bg-site bg-no-repeat bg-cover overflow-hidden'>
        <Nav />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/artistas" element={<Artistas />} />
          <Route path="/artistas/:id" element={<ArtistaLayout />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;